import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function ImagineScenario() {
  const benefits = ['Si tú o tu esposo enferman... están cubiertos', 'Si tus hijos necesitan ir al dentista... están cubiertos', 'Si necesitas lentes o un examen de la vista... están cubiertos', 'Si algo inesperado te pasa a ti... tu familia no queda desamparada', 'Si llegas al hospital de emergencia... no recibirás una factura que te quite el sueño'];
  return <section className="py-8 md:py-20 bg-cream relative" data-id="element-180">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-182">
          <div className="flex justify-center mb-3" data-id="element-183">
            <Star className="w-10 h-10 md:w-12 md:h-12 text-gold fill-gold/20" data-id="element-184" />
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-navy mb-3 md:mb-6" data-id="element-185">
            IMAGINA ESTE ESCENARIO...
          </h2>
          <p className="text-lg md:text-xl text-navy-light italic" data-id="element-186">
            Imagina despertar mañana sabiendo que:
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-187">
          {/* Family image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative order-2 lg:order-1" data-id="element-188">
            <div className="absolute -inset-4 bg-gradient-to-br from-gold/20 via-transparent to-navy/10 rounded-3xl blur-2xl" data-id="element-189" />
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-190">
              <img src="https://cdn.magicpatterns.com/uploads/eJYGGkoeErPxLf4rhXK6xz/u6414799714_Acouple_Mexican_family_with_Father_mother_around__d40dafc6-ec0f-43c6-a741-a5c16c728d99_1.png" alt="Familia latina protegida" className="w-full h-full object-cover aspect-[4/5] lg:aspect-[3/4]" data-id="element-191" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/30 via-transparent to-transparent" data-id="element-192" />
              <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-gold/20" data-id="element-193">
                <p className="font-serif italic text-navy text-sm md:text-base text-center" data-id="element-194">
                  "Tu familia, protegida. Tu tranquilidad, garantizada."
                </p>
              </div>
            </div>
          </motion.div>

          {/* Benefits list */}
          <div className="grid gap-3 md:gap-4 order-1 lg:order-2" data-id="element-195">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-3 md:gap-4 bg-white p-4 md:p-5 rounded-xl shadow-sm border border-gold/10 hover:border-gold/30 transition-colors" data-id="element-196">
                <div className="bg-green-50 p-2 rounded-full shrink-0" data-id="element-197">
                  <Check className="w-5 h-5 md:w-6 md:h-6 text-green-600" data-id="element-198" />
                </div>
                <span className="text-base md:text-lg text-navy font-medium leading-snug" data-id="element-199">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-10 md:mt-12 text-center" data-id="element-200">
          <p className="text-xl md:text-2xl font-serif text-navy mb-3" data-id="element-201">
            Esa tranquilidad no es un lujo.{' '}
            <span className="text-gold font-bold" data-id="element-202">Es tu derecho.</span>
          </p>
          <p className="text-base md:text-lg text-gray-600" data-id="element-203">
            Y yo puedo ayudarte a conseguirla.
          </p>
        </motion.div>
      </div>
    </section>;
}